import { ErrorString, InvalidOperationException } from "../../shared/index.js";
import { nextIterationAsync } from "./_nextIterationAsync.js";
import { typeDataToArray } from "./_typeDataToArray.js";
export const averageAsync = async (source, selector) => {
    const nextIter = nextIterationAsync(source, selector);
    const values = await typeDataToArray(nextIter);
    if (values.length === 0) {
        throw new InvalidOperationException(ErrorString.NoElements);
    }
    let value = 0;
    for (const selectedValue of values) {
        value += selectedValue;
    }
    return value / values.length;
};
